document.addEventListener("DOMContentLoaded", function(event) {
  setTimeout(function(){
    var complementary = document.querySelector('.products-complementary.hide');

    if (complementary !== null) {
      var tab = complementary.closest('.product-block--complementary');
      tab.remove();
    }
  }, 500);
});

document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("loyal")) {
        // Redirect to '?loyal' only, discarding other parameters
        const newUrl = `${window.location.pathname}?loyal`;

        // Check if the current URL is already simplified to '?loyal'
        if (window.location.search !== "?loyal") {
            window.location.href = newUrl; // Redirect to '?loyal'
        } else {
            console.log("Already on '?loyal', no further action needed.");
        }
    } else {
        console.log("The 'loyal' parameter is missing. No redirection performed.");
    }
});

/* ------------------------------------------------------------------
 * BK: Wrapped gift-wrapping launcher ("BK Premium Gift Wrapping")
 * Left-align the checkbox link and strip the app's invisible button
 * padding/margins. Wrapped renders inside a shadow root, so theme CSS
 * can't reach it; we inject a <style> into each shadow root and zero
 * the app's spacing variables on the host element.
 * ------------------------------------------------------------------ */
(function () {
  var STYLE_CLASS = 'bk-gift-launcher-style';
  var CSS = [
    'gift-block-launcher:not([variant="inline"]) {',
    '  align-items: flex-start !important;',
    '  gap: 0 !important;',
    '}',
    '.gift-block__launcher, .gift-block__launcher[variant="link"] {',
    '  margin: 0 !important;',
    '  padding: 0 !important;',
    '  width: auto !important;',
    '  max-width: none !important;',
    '  min-height: 0 !important;',
    '  text-align: left !important;',
    '  justify-content: flex-start !important;',
    '}',
    '.gift-block__launcher .button-content {',
    '  justify-content: flex-start !important;',
    '  width: auto !important;',
    '}',
    '.gift-block__launcher .label { text-align: left !important; }',
    /* Cart "gift wrap the order" uses Wrapped's solid button style; render it
       as the same plain checkbox + text used on the product page. */
    '.gift-block__launcher:not([variant="link"]) {',
    '  background: none !important;',
    '  border: none !important;',
    '  border-radius: 0 !important;',
    '  box-shadow: none !important;',
    '  color: var(--shadow-primary-text-color, currentColor) !important;',
    '  font-weight: var(--shadow-font-weight-base, normal) !important;',
    '}',
    '.gift-block__launcher:not([variant="link"]):hover,',
    '.gift-block__launcher:not([variant="link"]):active {',
    '  background: none !important;',
    '  border: none !important;',
    '  color: var(--shadow-primary-text-color--hover, var(--shadow-primary-text-color, currentColor)) !important;',
    '  text-decoration: underline;',
    '}',
    '.gift-block__launcher:not([variant="link"]) .button-content {',
    '  flex-direction: row !important;',
    '}'
  ].join('\n');

  var HOST_VARS = {
    '--shadow-block-margin-start': '0px',
    '--shadow-block-margin-end': '0px',
    '--shadow-block-margin-inline-start': '0px',
    '--shadow-block-margin-inline-end': '0px',
    '--shadow-block-padding': '0px',
    '--shadow-block-padding-block-start': '0px',
    '--shadow-block-padding-block-end': '0px',
    '--shadow-block-padding-inline-start': '0px',
    '--shadow-block-padding-inline-end': '0px',
    '--shadow-launcher-button-alignment': 'flex-start',
    '--shadow-launcher-button-content-justify-content': 'flex-start',
    '--shadow-launcher-button-content-flex-direction': 'row'
  };

  function styleRoot(root) {
    if (!root || root.querySelector('style.' + STYLE_CLASS)) return;
    var style = document.createElement('style');
    style.className = STYLE_CLASS;
    style.textContent = CSS;
    root.appendChild(style);
  }

  function watchHost(host) {
    if (!host.__bkGiftVars) {
      host.__bkGiftVars = true;
      Object.keys(HOST_VARS).forEach(function (k) { host.style.setProperty(k, HOST_VARS[k]); });
    }
    if (!host.shadowRoot) return;
    styleRoot(host.shadowRoot);
    if (host.__bkGiftWatched) return;
    host.__bkGiftWatched = true;
    // Re-add the style if Wrapped re-renders its shadow root.
    new MutationObserver(function () { styleRoot(host.shadowRoot); })
      .observe(host.shadowRoot, { childList: true });
  }

  function run() {
    document.querySelectorAll('wrapped-gift-block').forEach(watchHost);
  }

  function init() {
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
    [500, 1500, 3000, 6000].forEach(function (ms) { setTimeout(run, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
